import { adminHttpClient } from '../commons/adminHttpClient'
import { RecurringExpenseFrequency } from '../../domain/expenses/ReccuringExpenseFrequency'

export type SaveInsurancePremiumRequest = {
  recurringExpenseId?: string
  name: string
  expenseTypeId: number
  planPeriodId: string
  familyMemberId?: string
  familyMemberCoveredByThisPolicyIds: string
  requestedAmount: number
  startDate: string
  frequency: RecurringExpenseFrequency
  description: string
  attachments: AttachmentProps[]
  doesThisPolicyProvidesMec: boolean
  healthPlanSource: number
}

type AttachmentProps = {
  id?: string
  filename: string
  title: string
  reuseInOtherExpenses: boolean
}

const saveInsurancePremium = (values: SaveInsurancePremiumRequest): Promise<string> => {
  return adminHttpClient.post('/InsurancePremiums', values)
}

export default saveInsurancePremium
